/* eslint react/no-direct-mutation-state: "off",'array-callback-return': 'off','no-redeclare': 'off' ,eqeqeq: 'off',no-useless-escape: 'off', no-useless-concat: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { GetPreventativeMaintenanceList, GetWorkOrderBuildings } from "../../../../../action/workorderAction";
import { Table } from 'reactstrap';
import { createFilter } from "react-search-input";
import LoadingIndicator from '../../../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['serialNumber', 'name', 'buildingName', 'equipmentName'];

let PMList = [];
class PMUpcomingWork extends Component {


    componentWillMount() {
        if(this.props.PMList !== null && this.props.PMList !== undefined){
            PMList = this.props.PMList;
            this.setState({isloading: false});           
        }
        else {
            this.props.GetPreventativeMaintenanceList().then(() => {
            PMList = this.props.getPMList.PreventativeMaintenanceList;
            this.setState({isloading: false})          
            });           
        }

     
        var FilterDetails = sessionStorage.getItem('PMUFilterDetails');
        this.props.GetWorkOrderBuildings();

        if (FilterDetails !== undefined && FilterDetails !== null && FilterDetails !== "null") {
            var lFilterDetails = JSON.parse(FilterDetails);
            this.setState({ SearchFilterValue: lFilterDetails.filtervalue });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            SearchFilterValue: "3",
            sort: {
                column: null,
                direction: [
                    { name: 'id', direction: 'desc', onclick: false },
                    { name: 'name', direction: 'desc', onclick: false },
                    { name: 'buildingName', direction: 'desc', onclick: false },
                    { name: 'equipmentName', direction: 'desc', onclick: false }
                ]
            },
            SearchTerm: "",
            IsDefaultSort: true,
            PMId: 0,

        };
        this.onSortingNumber = this.onSortingNumber.bind(this);
        this.onSorting = this.onSorting.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.OnFilterChange = this.OnFilterChange.bind(this);
    }

    onSortingNumber = (column) => (e) => {
        this.setState({ IsDefaultSort: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = PMList;
        if (data_from_state != null) {
            const sortedData = PMList.sort((a, b) => {
                let nameA, nameB;
                nameA = a[column];
                nameB = b[column];
                return (nameA - nameB);
            });
            if (direction === 'desc') {
                sortedData.reverse();
            }

            if (selected[0].name === "id") {
                SortData[0].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "id") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            PMList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('PMUSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.SearchFilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('PMUFilterDetails', JSON.stringify(Data1));
        }
    };

    onSorting = (column) => (e) => {
        this.setState({ IsDefaultSort: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = PMList;
        var notequals = 0;
        if (data_from_state != null) {
            const sortedData = PMList.sort((a, b) => {
                let nameA, nameB;
                if (column === "name" || column === "buildingName" || column === "equipmentName") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                    if (nameA < nameB) {
                        notequals = 1;
                        return -1;
                    }
                    if (nameA > nameB) {
                        notequals = 1;
                        return 1;
                    }
                    if (nameA === nameB) {
                        return 0;
                    }
                    return 0;
                }

            });
            if (selected[0].direction === 'asc' && notequals === 1) {
                sortedData.reverse();
            }
            if (selected[0].name === "name") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "name") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name === "buildingName") {
                SortData[2].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "buildingName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name === "equipmentName") {
                SortData[3].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "equipmentName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }

            PMList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('PMUSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.SearchFilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('PMUFilterDetails', JSON.stringify(Data1));
        }
    };

    getWeek() {
        var l_today = new Date();
        let dayOfWeek = l_today.getDay(); //0-6
        let numDay = l_today.getDate();

        let start = new Date(l_today); 
        start.setDate(numDay - dayOfWeek);
        start.setHours(0, 0, 0, 0);


        let end = new Date(l_today); 
        end.setDate(numDay + (7 - dayOfWeek));
        end.setHours(0, 0, 0, 0);

        return [start, end];
    };

    searchUpdated(term) {
        this.setState({ SearchTerm: this.refs.search_value.value })
    };

    OnFilterChange() {
        var selectedOption = this.refs.filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.filter_in_Select_input.options[selectedOption].id;

        this.setState({ SearchFilterValue: lFilterId });
        var Data3 = ({ 'filtervalue': lFilterId });
        sessionStorage.setItem('PMUFilterDetails', JSON.stringify(Data3));
    };

    render() {

        let label, Data = [];
        label = this.props.getLabels;
        Data = PMList;
        if(Data !== null && Data !== undefined){
            if(this.state.SearchFilterValue !== "5")
                Data = Data.filter(a => a.isDueDatePassed === false);
            else
                Data = Data.filter(a => a.scheduleType === 2);
        }
       
        let PMPreferences = this.props.getPreferences;
        let Filters_in_Select_input;

        let PMUpcomingWorkList = [], StructuredData = [];
        let Buildings = this.props.getWorkOrderBuildings;
        //eslint-disable-next-line
        var Name = '', Building = '', Equipment = '';

        if (PMPreferences !== undefined && PMPreferences !== '') {

            Name = PMPreferences.filter(x => x.field === "Name" && x.display === true);
            Building = PMPreferences.filter(x => x.field === "Building" && x.display === true);
            Equipment = PMPreferences.filter(x => x.field === "Equipment" && x.display === true);
        }

        if (label['PMUpcomingWork.Filter.Options.Text'] !== undefined) {
            var Filters = label['PMUpcomingWork.Filter.Options.Text'].split(',');
            Filters_in_Select_input = Filters.map(el => (
                <option id={el} value={el} key={el} >{label['PMUpcomingWork.Filter.Options.' + el + '.Text']}</option>
            ));
        }


        if (Data !== undefined && Data !== null && Data.length && !this.state.isloading) {

            //Filter functionality
            if (this.state.SearchFilterValue !== "3") {
                if (this.state.SearchFilterValue === "2") { //Week
                    var date = this.getWeek();
                    Data = Data.filter(x => new Date(x.dueDate).setHours(0, 0, 0, 0) >= Number(date[0]) && new Date(x.dueDate).setHours(0, 0, 0, 0) <= Number(date[1]) && x.status !== 6);
                }
                else if (this.state.SearchFilterValue === "1") { // Today
                    var date = new Date();
                    date.setHours(0, 0, 0, 0);
                    Data = Data.filter(x => new Date(x.dueDate).setHours(0, 0, 0, 0) === Number(date) && x.status !== 6);
                }
                else if (this.state.SearchFilterValue === "4") { //Year
                    Data = Data.filter(x => new Date(x.dueDate).getFullYear() === new Date().getFullYear() && x.status !== 6);
                }
                else if (this.state.SearchFilterValue === "5") { //Based On Usage
                    Data = Data.filter(x => x.dueDate === "0001-01-01T00:00:00" )
                }
            }
            else { // Month
                var date = new Date();
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                Data = Data.filter(x => new Date(x.dueDate).setHours(0, 0, 0, 0) >= Number(firstDay) && new Date(x.dueDate).setHours(0, 0, 0, 0) <= Number(lastDay) && x.status !== 6);
            }

            if (this.state.IsDefaultSort) {
                var SortedDetails = sessionStorage.getItem('PMUSortingDetails');
                if (SortedDetails !== undefined && SortedDetails !== null && SortedDetails !== "null") {
                    var PSortedDetails = JSON.parse(SortedDetails);
                    var column = PSortedDetails.column;
                    var direction = PSortedDetails.direction.filter(x => x.onclick === true)[0].direction;

                    if (column === 'id') {
                        let sortedData = Data.sort((a, b) => {
                            let nameA, nameB;
                            nameA = a[column];
                            nameB = b[column];
                            return (nameA - nameB);
                        });
                        if (direction === 'desc') {
                            sortedData.reverse();
                        }
                        Data = sortedData;
                        this.state.sort = { column, direction: PSortedDetails.direction };
                    }
                    else {
                        let sortedData = Data.sort((a, b) => {
                            let nameA, nameB;
                            if (column === "name" || column === "buildingName" || column === "equipmentName") {
                                nameA = a[column].toLowerCase();
                                nameB = b[column].toLowerCase();
                            }

                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            if (nameA === nameB) {
                                return 0;
                            }
                            return 0;
                        });
                        if (direction === 'desc') {
                            sortedData.reverse();
                        }
                        Data = sortedData;
                        this.state.sort = { column, direction: PSortedDetails.direction };
                    }
                }
                else {
                    const data_from_state = Data;
                    // eslint-disable-next-line
                    var notequals = 0;
                    if (data_from_state != null) {
                        var TextRecords = [], NumberRecords = [], DateRecords = [];
                        data_from_state.forEach(el => {
                            var DueDate = (el.dueDate === "1753-01-01T00:00:00" || el.dueDate === "0001-01-01T00:00:00") ? "---" : el.dueDate;
                            if (el.scheduleType === 2) {
                                if (el.remainingUsage === null)
                                    TextRecords.push(el);
                                else {
                                    if (el.remainingUsage === 0)
                                        DateRecords.push(el);
                                    else
                                        NumberRecords.push(el);
                                }
                            } else {
                                if (DueDate !== "---")
                                    DateRecords.push(el);
                                else
                                    TextRecords.push(el);
                            }
                        });

                        const sortedDateData = DateRecords.sort((a, b) => {
                            let nameA, nameB;
                            nameA = new Date(a['dueDate']);
                            nameB = new Date(b['dueDate']);
                            if (nameA < nameB) {
                                notequals = 1;
                                return -1;
                            }
                            if (nameA > nameB) {
                                notequals = 1;
                                return 1;
                            }
                            if (nameA === nameB) {
                                return 0;
                            }
                            return 0;
                        });
                        sortedDateData.reverse();

                        const sortedNumberData = NumberRecords.sort((a, b) => {
                            let nameA, nameB;
                            nameA = a['remainingUsage'];
                            nameB = b['remainingUsage'];
                            return (nameA - nameB);
                        });
                        sortedNumberData.reverse();

                        Data = [];
                        sortedDateData.map(el => {
                            Data.push(el);
                        });
                        TextRecords.map(el => {
                            Data.push(el);
                        });
                        sortedNumberData.map(el => {
                            Data.push(el);
                        });
                    }
                }
            }

            Data.forEach(el => {
                var buildingdts = [];
                if (Buildings !== null && Buildings !== undefined && Buildings.length > 0) {
                    buildingdts = Buildings.filter(function (item) {
                        return item.id === el.buildingId
                    });
                }
                var l_EquipmentName = el.equipmentName !== "" ? el.equipmentName : '---';




                var lineitem = {
                    "id": el.id,
                    "name":  el.name !== "" ? el.name : <b>---</b>,
                    "serialNumber": el.serialNumber,
                    "title": el.name !== "" ? el.name : <b>---</b>,
                    "equipmentName": el.equipmentName !== "" ? el.equipmentName : <b>---</b>,
                    "buildingName": el.buildingId !== 0 && buildingdts !== [] && buildingdts[0] !== undefined ? buildingdts[0].name : <b>---</b>,
                    "equipment": el.equipmentId !== 0 ? l_EquipmentName : <b>---</b>
                }
                StructuredData.push(lineitem);
            });

            let FilteredData = StructuredData.filter(createFilter(this.state.SearchTerm, KEYS_TO_FILTERS));


            PMUpcomingWorkList = FilteredData.length ? FilteredData.map(el => (
                <tr key={el.serialNumber}>
                    <td>
                        {
                            <p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => {this.props.redirect_WO_PM_Details(el.id,el.serialNumber)}}>{el.serialNumber}</p>
                        }
                    </td>
                    {Name.length > 0 ? <td>{el.name}</td> : ''}
                    {Building.length > 0 ? <td>{el.buildingName}</td> : ''}
                    {Equipment.length > 0 ? <td>{el.equipmentName}</td> : ''}

                </tr>
            )) : <tr><td colSpan="4">{label['WorkOrders.Table.Default.Text']}</td></tr>;
        }
        else if(!this.state.isloading) {
            PMUpcomingWorkList = <tr><td colSpan="4">{label['WorkOrders.Table.Default.Text']}</td></tr>;
        } 
        else{
            PMUpcomingWorkList = <tr><td colSpan="4" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }


        let PMListTable = <div className="table_container table_border" id="divPrintWindow" style={{ 'marginBottom': '0px', 'marginLeft': '0px', 'marginTop': '-3px' }}>
            <Table  striped responsive className="Custom_table fixed_layout" id="kpi_UpcomingPM_table"  >
                <thead  className="cell_container_header">
                    <tr>
                        <th className="wo_cursor" onClick={this.onSortingNumber('id')}>
                            <span>{label !== undefined && label['PreventativeMaintenance.Columns.Record.Text'] !== undefined ? label['PreventativeMaintenance.Columns.Record.Text'] : "Record#"}</span>
                            <span className={(this.state.sort.direction[0].name === "id") ?
                                (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>

                        
                            <th className="wo_cursor" onClick={this.onSorting('name')}>{Name.fieldLabel > 0 ? Name[0].fieldLabel : "Name" } 
                                <span className={(this.state.sort.direction[1].name === "name") ?
                                    (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[1].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> 
                        

                       
                            <th className="wo_cursor" onClick={this.onSorting('buildingName')}>{Building.fieldLabel > 0 ? Building[0].fieldLabel : "Building" }
                                <span className={(this.state.sort.direction[2].name === "buildingName") ?
                                    (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[2].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> 
                       

                        
                            <th className="wo_cursor" onClick={this.onSorting('equipmentName')}>{Equipment.fieldLabel > 0 ? Equipment[0].fieldLabel : "Equipment"}
                                <span className={(this.state.sort.direction[3].name === "equipmentName") ?
                                    (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[3].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> 
                       

                    </tr>
                    </thead>
                    <tbody className="cell_container kpi_table_tbody cell_container_body">
                    {PMUpcomingWorkList}
                    </tbody>
                
            </Table>
        </div>




        return (
            <div className="main_container box_border">
                <label style={{ fontFamily: 'lato', fontSize: '15px', fontWeight: 'bold', color: 'black' }}>Upcoming Preventative Maintenance</label><br />
                
                <div className="row row_padding" style={{"marginTop": "10px"}}>
                    <div className="col-md-12">
                    <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black' }}>{label !== undefined ?
                            label['PMUpcomingWork.Filter.TimeRange.Text'] : "Due Date:"}</label>
                        <select ref='filter_in_Select_input' style={{ marginLeft: '5px' }} className="pmminimal pm-dropdown" placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.OnFilterChange} value={this.state.SearchFilterValue}>
                            {Filters_in_Select_input}
                        </select>
                        <span className="pm_outersearchbox" style={{ float: 'right' }}>
                            <input type="text" id="kpi_UpcomingPM_search" className="pm_searchbox" style={{ paddingLeft: '10px', marginTop: '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='search_value' />
                        </span>
                        <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', marginTop : '3px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                    </div>
                </div>

                <p />
                {PMListTable}


            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getPMList: state.WorkorderRootReducer,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
        User_Details: state.userDetailsRootReducer,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetPreventativeMaintenanceList: () => dispatch(GetPreventativeMaintenanceList()),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PMUpcomingWork);